import { PartState } from '../types';
import { curiousState } from './curious';

/**
 * Straight-on state — Bizy looking directly at the viewer with centered,
 * symmetrical features. Eyes and badge are centered on the face.
 * Wings are evenly spread on both sides.
 */
export const straightOnState: PartState = {
	antenna1: curiousState.antenna1,
	antenna2: curiousState.antenna2,
	body: curiousState.body,
	bodyHighlight: curiousState.bodyHighlight,
	stripes: curiousState.stripes,
	eyes: {
		leftPath:
			'M124 100.5C124 97.462 126.462 95 129.5 95C132.538 95 135 97.462 135 100.5C135 100.5 135 107.5 135 107.5C135 110.538 132.538 113 130 113C129.5 113 129.5 113 129 113C126.462 113 124 110.538 124 107.5C124 107.5 124 100.5 124 100.5Z',
		rightPath:
			'M163 100.5C163 97.462 165.462 95 168.5 95C171.538 95 174 97.462 174 100.5C174 100.5 174 107.5 174 107.5C174 110.538 171.538 113 169 113C168.5 113 168.5 113 168 113C165.462 113 163 110.538 163 107.5C163 107.5 163 100.5 163 100.5Z',
	},
	wing1Path:
		'M219.585 133.33C199.695 155.59 150.615 152.03 131.745 150.5C130.285 150.33 129.505 148.54 130.345 147.3C154.145 112.11 200.175 86.1399 224.085 75.2099C248.825 63.9899 237.035 115.71 219.585 133.33Z',
	wing2Path:
		'M223.545 157.891C202.315 174.551 153.545 150.981 136.955 142.191C135.635 141.531 135.505 139.591 136.715 138.701C166.345 112.071 220.245 104.931 243.655 102.201C267.825 99.4505 243.645 149.241 223.545 157.891Z',
	wing3Path:
		'M87.1844 133.33C107.074 155.59 156.154 152.03 175.024 150.5C176.484 150.33 177.264 148.54 176.424 147.3C152.624 112.11 106.594 86.1399 82.6844 75.2099C57.9444 63.9899 69.7344 115.71 87.1844 133.33Z',
	wing4Path:
		'M83.2244 157.891C104.454 174.551 153.224 150.981 169.814 142.191C171.134 141.531 171.264 139.591 170.054 138.701C140.424 112.071 86.5244 104.931 63.1144 102.201C38.9444 99.4505 63.1244 149.241 83.2244 157.891Z',
	arms: curiousState.arms,
	armOrder: 'bothFront',
	antennaOrder: 'bothFront',
	stinger: curiousState.stinger,
	badge: {
		outerEllipse: { cx: 176, cy: 143.76, rx: 14.1, ry: 10.86 },
		innerEllipse: { cx: 176, cy: 143.76, rx: 12.19, ry: 9.34 },
		starPath:
			'M176 130.58C176.75 130.58 177.4 131.09 177.6 131.82L179.55 139.24L185.09 142.47C185.6 142.77 185.91 143.32 185.91 143.91C185.91 144.51 185.6 145.06 185.09 145.36L179.55 148.59L177.6 156.01C177.4 156.74 176.75 157.25 176 157.25C175.25 157.25 174.6 156.74 174.4 156.01L172.45 148.59L166.91 145.36C166.4 145.06 166.09 144.51 166.09 143.91C166.09 143.32 166.4 142.77 166.91 142.47L172.45 139.24L174.4 131.82C174.6 131.09 175.25 130.58 176 130.58Z',
		starHighlightPath:
			'M177.6 131.82C177.4 131.09 176.75 130.58 176 130.58C175.25 130.58 174.6 131.09 174.4 131.82L172.45 139.24L166.91 142.47L174.98 144.88C175.65 145.08 176.35 145.08 177.02 144.88L185.09 142.47L179.55 139.24L177.6 131.82Z',
	},
};
